
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, VModel } from 'vue-property-decorator';

@Component
export default class MonthCloseConfirmDialog extends Vue {
  @VModel()
  public show!: boolean;

  @Prop({ required: true })
  public period!: string;

  public onConfirm(): void {
    this.$emit('confirm');
    this.show = false;
  }
}
